import React, { Suspense, useEffect } from 'react';
import TableSkeleton from '../../../components/TableSkeleton';
import ReorderTable from '../../../components/ReorderTable';
import { ExtDataCategoriesProvider, useExtDataCategories } from '../../../contexts/extractions/ExtDataCategoryContext';
import QueryBuilder from './QueryBuilder';
import { useDispatch, useSelector } from 'react-redux';
import ConfirmDialog from '../../../components/ConfirmDialog';
import Spinner from '../../../components/Spinner';
import { createExtDataCategory, updateExtDataCategory } from "../../../store/extDataCategories/actions";
import { Button } from '../../../components/ui/button';
import { setOpenModal } from '../../../store/extVersions/actions';

const ExtDataCategories = () => {
    const dispatch = useDispatch();
    const {
        table,
        columns,
        openAddModal,
        extDataCategories,
        handleDelete,
        handleCloseModal,
        showDeleteConfirmationDialog,
        handleRowReorder,
        getRowId,
    } = useExtDataCategories();

    const { loading, extDataCategory, openModal } = useSelector((state) => state.ExtDataCategories);
    const { columnListValues, fieldValueOptionsMap, extractionViewOnly } = useSelector((state) => state.Extractions);

    useEffect(() => {
        dispatch(setOpenModal(false));
        return () => {
            dispatch(setOpenModal(false));
        };
    }, [dispatch]);

    return (
        <>
            <div className="flex justify-between mb-4">
                <div className="text-lg font-semibold text-primary">
                    Please define the data categories here
                </div>
                <Button onClick={openAddModal} disabled={extractionViewOnly}>
                    Add New Data Category
                </Button>
            </div>

            
            <Suspense fallback={<TableSkeleton columns={5} rows={5} headers={["#", "Code", "Title", "Actions"]}/>}> 
                <ReorderTable
                    loading={loading}
                    table={table}
                    data={extDataCategories || []}
                    columns={columns}
                    pagination={false}
                    enableRowReordering={true}
                    onRowReorder={handleRowReorder}
                    getRowId={getRowId}
                />
            </Suspense>

            {/* Single QueryBuilder handles both create and edit */}
            {openModal && (
                <QueryBuilder
                    options={columnListValues}
                    fieldDropdownOptions={fieldValueOptionsMap}
                    editMode={!!extDataCategory}
                    triggerText={extDataCategory ? "Edit" : "Add New Data Category"}
                    titleText={extDataCategory ? "Edit Data Category" : "Add New Data Category"}
                    nameLabel="Data Category Name"
                    namePlaceholder="Enter data category name"
                    createAction={createExtDataCategory}
                    updateAction={updateExtDataCategory}
                    data={extDataCategory}
                    openModal={openModal}
                    disabled={extractionViewOnly}
                    saveInProgress={loading}
                />
            )}
            
            <Suspense fallback={<Spinner/>}>
                <ConfirmDialog
                    open={showDeleteConfirmationDialog}
                    confirmAction={handleDelete}
                    handleClose={e => handleCloseModal('delete')}
                    actionText="Delete"
                    descriptionText="Are you sure you want to delete this Data Category?"
                />
            </Suspense>
        </>
    );
};

const ExtDataCategoriesPage = () => {
    return (
        <ExtDataCategoriesProvider>
            <ExtDataCategories />
        </ExtDataCategoriesProvider>
    );
};

export default ExtDataCategoriesPage;